import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useParams, useNavigate } from "react-router-dom";
import "./../../../assets/css/popup.css";
import {
  getConfigurations,
  updateConfigurations,
} from "../../../apis/ConfigurationsApi";
import { validationsForConfiguration } from "../../../Validations/ConfigurationsCampaignValidations";

export default function UpdateConfigurations() {
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const [initialValues, setInitialValues] = useState({
    appVersion: "",
    changeNav: "",
    crmCurrentCampaign: "",
    cutOfShareClassDate: "",
    nav: "",
    hmInvestorCnt: "",
    ARFGroceryChains: "",
    isBanner: "",
    banner: "",
  });

  useEffect(() => {
    if (id) {
      fetchConfiguration(id);
    }
  }, [id]);

  const fetchConfiguration = async (id) => {
    setLoader(true);
    try {
      const res = await getConfigurations(id);
      if (res.result) {
        const data = res.result;
        console.log("Fetched Configuration Data:", data[0]?.isBanner);
        setInitialValues({
          appVersion: data[0]?.appVersion || "",
          changeNav: data[0]?.changeNav || "",
          nav: data[0]?.nav,
          crmCurrentCampaign: data[0]?.crmCurrentCampaign || "",
          cutOfShareClassDate: data[0]?.cutOfShareClassDate || "",
          hmInvestorCnt: data[0]?.hmInvestorCnt || "",
          ARFGroceryChains: data[0]?.ARFGroceryChains || "",
          isBanner:
            data[0]?.isBanner === true
              ? "true"
              : data[0]?.isBanner === false
              ? "false"
              : "",
          banner: data[0]?.banner || "",
        });
      }
    } catch (error) {
      console.error("Error fetching configuration:", error);
    } finally {
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: validationsForConfiguration,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const res = await updateConfigurations(id, values);

        navigate("/configurations");
      } catch (error) {
        console.error("Error updating configuration:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const backClick = () => navigate("/configurations");

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <i
            className="fas fa-arrow-left"
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={backClick}
          />
          <div className="my-3 p-3 bg-body rounded shadow-sm">
            <h3>Edit Configuration</h3>

            {loader ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "50px" }}
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                <div className="mb-3">
                  <label className="form-label">App Version</label>
                  <input
                    type="text"
                    className="form-control"
                    name="appVersion"
                    placeholder="Enter App Version"
                    value={formik.values.appVersion}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.appVersion && formik.errors.appVersion && (
                    <div className="text-danger">
                      {formik.errors.appVersion}
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Change Navigation</label>
                  <input
                    type="number"
                    className="form-control"
                    name="changeNav"
                    placeholder="Enter Change Navigation Value"
                    value={formik.values.changeNav}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.changeNav && formik.errors.changeNav && (
                    <div className="text-danger">{formik.errors.changeNav}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Nav</label>
                  <input
                    type="number"
                    className="form-control"
                    name="nav"
                    placeholder="Enter Nav"
                    value={formik.values.nav}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nav && formik.errors.nav && (
                    <div className="text-danger">{formik.errors.nav}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">CRM Current Campaign</label>
                  <input
                    type="text"
                    className="form-control"
                    name="crmCurrentCampaign"
                    placeholder="Enter CRM Current Campaign"
                    value={formik.values.crmCurrentCampaign}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.crmCurrentCampaign &&
                    formik.errors.crmCurrentCampaign && (
                      <div className="text-danger">
                        {formik.errors.crmCurrentCampaign}
                      </div>
                    )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Cut Off Share Class Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="cutOfShareClassDate"
                    value={formik.values.cutOfShareClassDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.cutOfShareClassDate &&
                    formik.errors.cutOfShareClassDate && (
                      <div className="text-danger">
                        {formik.errors.cutOfShareClassDate}
                      </div>
                    )}
                </div>
                <div className="mb-3">
                  <label className="form-label">HM Investor Count</label>
                  <input
                    type="number"
                    className="form-control"
                    name="hmInvestorCnt"
                    placeholder="Enter HM Investor Count"
                    value={formik.values.hmInvestorCnt}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.hmInvestorCnt &&
                    formik.errors.hmInvestorCnt && (
                      <div className="text-danger">
                        {formik.errors.hmInvestorCnt}
                      </div>
                    )}
                </div>
                <div className="mb-3">
                  <label className="form-label">ARF Grocery Chains</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ARFGroceryChains"
                    placeholder="Enter ARF Grocery Chains"
                    value={formik.values.ARFGroceryChains}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.ARFGroceryChains &&
                    formik.errors.ARFGroceryChains && (
                      <div className="text-danger">
                        {formik.errors.ARFGroceryChains}
                      </div>
                    )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Is Banner</label>
                  <select
                    className="form-control"
                    name="isBanner"
                    value={formik.values.isBanner}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {formik.touched.isBanner && formik.errors.isBanner && (
                    <div className="text-danger">{formik.errors.isBanner}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Banner</label>
                  <input
                    type="text"
                    className="form-control"
                    name="banner"
                    placeholder="Enter Banner"
                    value={formik.values.banner}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.banner && formik.errors.banner && (
                    <div className="text-danger">{formik.errors.banner}</div>
                  )}
                </div>

                <div className="mt-4">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
